import React from 'react'
import {css} from '@emotion/core'
import Carousel, {consts} from 'react-elastic-carousel'

import PremierLabel from './premier-label'
import fourteenFour from '../../img/partner-logos/14four-logo.png'
import hoopla from '../../img/partner-logos/hoopla-logo.png'
import innovationRocks from '../../img/partner-logos/innovation-rocks-logo.png'
import mawari from '../../img/partner-logos/mawari-logo.png'
import powster from '../../img/partner-logos/powster-logo.png'
import spark from '../../img/partner-logos/spark-logo.png'
import trigger from '../../img/partner-logos/trigger-logo.png'
import unbnd from '../../img/partner-logos/unbnd-logo.png'
import aircards from '../../img/partner-logos/aircards-logo.png'
import fourteenFourWebp from '../../img/partner-logos/14four-logo.webp'
import hooplaWebp from '../../img/partner-logos/hoopla-logo.webp'
import innovationRocksWebp from '../../img/partner-logos/innovation-rocks-logo.webp'
import mawariWebp from '../../img/partner-logos/mawari-logo.webp'
import powsterWebp from '../../img/partner-logos/powster-logo.webp'
import sparkWebp from '../../img/partner-logos/spark-logo.webp'
import triggerWebp from '../../img/partner-logos/trigger-logo.webp'
import unbndWebp from '../../img/partner-logos/unbnd-logo.webp'
import aircardsWebp from '../../img/partner-logos/aircards-logo.webp'

export interface IPartnerCard {
  logo: string,
  link: string,
  from?: string, // for a8 eventing
  partnerName?: string, // for a8 eventing
  logoWebp?: string,
}

const PartnerCard: React.FunctionComponent<IPartnerCard> = (
  {logo, link, from, partnerName, logoWebp}
) => (
  <a
    target='_blank'
    rel='noopener noreferrer'
    href={link}
    className='partner-card'
    a8={from && `click;${from};click-partner-logo-${partnerName}`}
  >
    <div
      className='card align-items-center shadow'
      css={css`
          min-width: 0;
          min-height: 0;
          height: 275px;
          width: 275px;
          border-radius: 10px;
          margin: 0;
          @media screen and (max-width: 767px) {
            width: 175px;
            height: 175px;
          }
        `}
    >
      <div style={{maxWidth: '70%', margin: 'auto'}}>
        <picture>
          {logoWebp && <source srcSet={logoWebp} type='image/webp' />}
          <img className='card-img' src={logo} alt='Studio Logo' />
        </picture>
      </div>
      <PremierLabel bottom right />
    </div>
  </a>
)


const Partners = [
  // Aircards
  {
    name: 'aircards', // for a8 eventing
    logo: aircards,
    logoWebp: aircardsWebp,
    link: 'https://www.aircards.co/',
  },

  // Hoopla Digital
  {
    name: 'hoopla-digital', // for a8 eventing
    logo: hoopla,
    logoWebp: hooplaWebp,
    link: 'https://hoopladigital.co.uk/hooplar/',
  },

  // innovation.rocks
  {
    name: 'innovation-rocks', // for a8 eventing
    logo: innovationRocks,
    logoWebp: innovationRocksWebp,
    link: 'https://innovation-rocks.com',
  },

  // Mawari
  {
    name: 'mawari', // for a8 eventing
    logo: mawari,
    logoWebp: mawariWebp,
    link: 'https://mawari.co.jp/',
  },

  // Powster
  {
    name: 'powster', // for a8 eventing
    logo: powster,
    logoWebp: powsterWebp,
    link: 'https://powster.com/',
  },

  // Spark
  {
    name: 'spark', // for a8 eventing
    logo: spark,
    logoWebp: sparkWebp,
    link: 'https://www.spark-lab.co.uk/what-we-do/augmented-reality',
  },

  // Trigger
  {
    name: 'trigger', // for a8 eventing
    logo: trigger,
    logoWebp: triggerWebp,
    link: 'https://www.triggerglobal.com/',
  },

  // UNBND
  {
    name: 'unbnd', // for a8 eventing
    logo: unbnd,
    logoWebp: unbndWebp,
    link: ' https://unbnd.com.au/ ',
  },

  // 14Four
  {
    name: '14-four', // for a8 eventing
    logo: fourteenFour,
    logoWebp: fourteenFourWebp,
    link: 'https://www.14four.com/',
  },
]

interface IPartnerCarousel {
  from?: string, // for a8 eventing
}

const PartnerCarousel: React.FunctionComponent<IPartnerCarousel> = ({from}) => {
  const carouselBreakPoints = [
    {width: 1, itemsToShow: 1.3},
    {width: 400, itemsToShow: 2.25, itemsToScroll: 1},
    {width: 950, itemsToShow: 3.25},
  ]

  const myArrow = ({type, onClick, isEdge}) => {
    const pointer = type === consts.PREV ? '‹' : '›'
    return (
      <button
        className='my-arrow'
        type='button'
        onClick={onClick}
        disabled={isEdge}
        css={css`
          font-size: 4em;
          color: #2D2E43;
          outline: none !important;
          @media screen and (max-width: 767px) {
            display: none;
          }
        `}
      >
        {pointer}
      </button>
    )
  }

  return (
    <div className='row justify-content-center'>
      <div className='col-12' style={{maxWidth: '1200px'}}>
        <Carousel
          renderArrow={myArrow}
          breakPoints={carouselBreakPoints}
          itemPadding={[20, 50]}
        >
          {Partners.map(data => <PartnerCard key={data.link} from={from} {...data} />)}
        </Carousel>
      </div>
    </div>
  )
}

export default PartnerCarousel
